import Link from "next/link";
import { useState, useEffect } from "react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "../../shadcn/navigation-menu";
import LoginButton from "../buttons/LoginButton";
import { Button } from "../../shadcn/button";

const LoginNavigation = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <>
      {/* Mobile: Direct Link */}
      <div className="block md:hidden">
        <LoginButton />
      </div>

      {/* Desktop: Hover Menu */}
      <div className="hidden md:block">
        {mounted && (
          <NavigationMenu viewport={false} delayDuration={0}>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuTrigger className="p-0">
                  <LoginButton />
                </NavigationMenuTrigger>
                <NavigationMenuContent>
                  <div className="w-40 space-y-1.5 p-1">
                    <Button asChild className="w-full">
                      <Link href="/auth/login">Giriş Yap</Link>
                    </Button>
                    <Button asChild variant="outline" className="w-full">
                      <Link href="/auth/register">Kayıt Ol</Link>
                    </Button>
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        )}
        {!mounted && <LoginButton />}
      </div>
    </>
  );
};

export default LoginNavigation;